import React from 'react'

const AquaLoader = () => {
    return (
        <div className="aqua-loader-main">
            {/* <p>
                <img className="" src="https://cdn.shopify.com/s/files/1/0084/6957/7794/files/Fish2.gif?50060" alt="Aqualens Contact lenses" />
            </p> */}
            <div className="aqua-razorpay-loader">

            </div>

        </div>
    )
}

export default AquaLoader
